import { DateTime } from 'luxon'

export function calculateDuration(
  arrival: string | Date,
  departure?: string | Date
): string {
  const startTime = DateTime.fromISO(arrival.toString())
  // If departure is not provided, calculate duration until now for ongoing visits
  const endTime = departure
    ? DateTime.fromISO(departure.toString())
    : DateTime.now()

  // Ensure diff is non-negative
  const diff = endTime.diff(startTime, ['hours', 'minutes'])

  const hours = Math.floor(diff.hours)
  const minutes = Math.floor(diff.minutes)

  if (hours === 0) {
    return `${minutes}m`
  }
  return `${hours}h ${minutes}m`
}

export function formatTime(
  dateInput: string | Date | undefined,
  placeholder: string = '---'
): string {
  if (!dateInput) {
    return placeholder
  }
  return DateTime.fromISO(dateInput.toString()).toFormat('HH:mm')
}

/**
 * Convert a date string to PST and return just the date portion
 */
export function getDateInPST(dateString: string): DateTime {
  return DateTime.fromISO(dateString)
    .setZone('America/Los_Angeles')
    .startOf('day')
}

/**
 * Get a formatted date string for use as group headers
 */
export function getDateHeaderId(dateString: string): string {
  const pstDate = getDateInPST(dateString)
  return `date-${pstDate.year}-${pstDate.month}-${pstDate.day}`
}

/**
 * Format a date for display in group headers
 */
export function formatDateForHeader(dateString: string): string {
  const pstDate = getDateInPST(dateString)
  return pstDate.toFormat('EEE M/d')
}
